import Icon from '../../Icon/Icon.js';
import { HotelHitBottomLink as HotelHitBottomLink$2 } from './styles/hotelHitBottomLink.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { USER_INTERFACE_ARROW_04_RIGHT } from '../../IconPath/USER_INTERFACE_ARROW_04_RIGHT.js';

var HotelHitBottomLink = function HotelHitBottomLink(_ref) {
  var text = _ref.text,
    url = _ref.url,
    target = _ref.target,
    onClick = _ref.onClick;
  if (!text || !url) {
    return null;
  }
  return /*#__PURE__*/jsxs(HotelHitBottomLink$2, {
    href: url,
    onClick: onClick,
    target: target,
    children: [text, /*#__PURE__*/jsx(Icon, {
      className: "sg-hotel-hit-bottom__link-icon",
      path: USER_INTERFACE_ARROW_04_RIGHT,
      size: "xxs"
    })]
  });
};
HotelHitBottomLink.defaultProps = {
  target: '_self',
  onClick: null
};
var HotelHitBottomLink$1 = HotelHitBottomLink;

export { HotelHitBottomLink$1 as default };
//# sourceMappingURL=HotelHitBottomLink.js.map
